/**
 * Checks if the current environment is one of (dev, alpha, beta, prod) or local development environment.
 * Returns false for "outside" environment (multimedia-upload-anywhere.bloomberg.com).
 */
export const isNotOutsideEnvironment = (): boolean => {
  const hostname = window.location.hostname;

  if (hostname === "multimedia-upload-anywhere.bloomberg.com") {
    return false;
  }

  const isDevEnvironment = hostname.includes(".dev.bloomberg.com");
  const isAlphaEnvironment = hostname.includes(".alpha.bloomberg.com");
  const isBetaEnvironment = hostname.includes(".beta.bloomberg.com");
  const isProdEnvironment = hostname.includes(".prod.bloomberg.com");
  const isLocalEnvironment =
    hostname === "localhost" || hostname.includes("127.0.0.1");

  return (
    isDevEnvironment ||
    isAlphaEnvironment ||
    isBetaEnvironment ||
    isProdEnvironment ||
    isLocalEnvironment
  );
};

export const getCurrentEnvironment = (): string => {
  const hostname = window.location.hostname;

  if (hostname === "multimedia-upload-anywhere.bloomberg.com") {
    return "outside";
  } else if (hostname.includes(".dev.bloomberg.com")) {
    return "dev";
  } else if (hostname.includes(".alpha.bloomberg.com")) {
    return "alpha";
  } else if (hostname.includes(".beta.bloomberg.com")) {
    return "beta";
  } else if (hostname.includes(".prod.bloomberg.com")) {
    return "prod";
  } else if (hostname === "localhost" || hostname.includes("127.0.0.1")) {
    return "local";
  }

  return "unknown";
};
